import { DRAWER_CONTEXT } from '@models/DrawerContext';
import { SideDrawerState } from '@models/sideDrawerState';
import { create } from 'zustand';

export const useSideDrawerStore = create<SideDrawerState>((set) => ({
  isOpen: false,
  context: DRAWER_CONTEXT.CREATE_PRODUCT,
  selectedId: null,
  prefillProductId: null,
  prefillLocationId: null,
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  handleClose: () =>
    set({
      isOpen: false,
      selectedId: null,
      prefillProductId: null,
      prefillLocationId: null,
    }),
  handleOpen: () => set({ isOpen: true }),
  setContext: (context: DRAWER_CONTEXT) => set({ context }),
  setSelectedId: (id: string | null) => set({ selectedId: id }),
  setPrefillProductId: (id: string | null) => set({ prefillProductId: id }),
  setPrefillLocationId: (id: string | null) => set({ prefillLocationId: id }),
}));
